import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationLanguageUpdatedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_LANGUAGE_UPDATED'>;
};

export const ConversationLanguageUpdated = ({
  entry,
}: ConversationLanguageUpdatedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const text = (
    <>
      Conversation language is changed to{' '}
      {entry.language && entry.language.toLowerCase()}{' '}
      {authorLink && <>by {authorLink}</>}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
